export { default as PhoneLink } from './PhoneLink';

export const HelplinePhoneNumber = '8773499449';
export const NurseLinePhoneNumber = '8443426276';
